/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Imageviewer_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Image viewer" |
*
* @param {Spaces_Imageviewer_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_imageviewer_aria_label = /** @type {((inputs?: Spaces_Imageviewer_Aria_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Imageviewer_Aria_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bild-Betrachter")
	return /** @type {LocalizedString} */ ("Image viewer")
});